import api from '@/api/app';
import { mapGetters } from 'vuex';
import loadingMixin from './loading';
import { Toast } from 'cube-ui';

export default {
  computed: {
    ...mapGetters(['schoolIps', 'visitorInfo'])
  },
  mixins: [loadingMixin],
  methods: {
    /**
     * 获取用户对应校本服务器IP地址
     * @param {String} schoolName 学校名称
     * @param {Boolean} isVisitor 是否是分享页登录
     */
    getSchoolIp(schoolName, isVisitor = false) {
      this.$store.commit('SET_SCHOOL_NAME', schoolName);
      this.changeLoadingStatus(true);
      api
        .fetchSchoolIps({
          schoolName
        })
        .then(response => {
          if (response.result) {
            if (isVisitor) {
              this.$store.commit('SET_VISITOR_SCHOOL_IPS', response.result);
            } else {
              this.$store.commit('SET_SCHOOL_IPS', response.result);
            }

            this.getVideoList && this.getVideoList();
            this.getVideoDetail && this.getVideoDetail(); // 视频分享页
            this.$refs.courseList && this.$refs.courseList.getCourseList();
            this.isVideo && this.getResUserId();
          } else {
            this.list = [];
            if (this.$refs.courseList) {
              this.$refs.courseList.list = [];
            }
            if (isVisitor) {
              this.$store.commit('SET_VISITOR_SCHOOL_IPS', []);
            } else {
              this.$store.commit('SET_SCHOOL_IPS', []);
            }

            if (this.timer) {
              clearInterval(this.timer);
            }

            Toast.$create({
              type: 'text',
              txt: `没有找到您的学校“${schoolName}”对应的服务器配置`
            }).show();

            this.changeLoadingStatus(false);
          }
        });
    },
    getResUserId() {
      const params = {
        userMobile: this.visitorInfo.mobile,
        ip: this.$findTargetSchoolIp(this.schoolIps, 2)
      };
      api
        .fetchResUserId(params)
        .then(response => {
          if (response.result) {
            this.$store.commit('SET_VISITOR_INFO', {
              resUserId: response.result.userId
            });
            this.hide && this.hide();
          }
        })
        .catch(error => {
          console.log('getResUserId error = ', error);
        });
    }
  }
};
